import { handleTrack } from '../../../utils/tracker';
import { Button } from '../../Atoms/Button';
import { If } from '../../Atoms/Conditionals';
import { Heading, HeadingType } from '../../Typography';

interface ISectionHeader {
  heading: string;
  description?: string | React.ReactNode;
  align?: 'center' | 'left';
  className?: string;
  id?: string;
  ctaText?: string;
  ctaLink?: string;
  descriptionClassName?: string;
}

const SectionHeader: React.FC<ISectionHeader> = ({
  heading,
  description,
  align = 'center',
  className = 'text-s-48 mb-6 sm:text-s-32',
  descriptionClassName = 'font-medium text-font-200 sm:text-base sm:mb-9 mb-12 sm:text-center',
  id = '',
  ctaLink,
  ctaText,
}) => {
  const textClass = align === 'center' ? 'text-center' : 'text-left';
  return (
    <div
      className={`${textClass} sm:text-left ${
        ctaLink && ctaText ? 'flex items-center justify-between' : ''
      }`}
    >
      <div>
        <Heading
          content={heading}
          variant={HeadingType.h2}
          className={`${className} sm:text-center`}
          id={id}
        />
        <If condition={!!description}>
          <p className={descriptionClassName} id={id}>
            {description}
          </p>
        </If>
      </div>
      <div>
        <If condition={Boolean(ctaText && ctaLink)}>
          <a
            href={ctaLink}
            rel="noreferrer"
            className="text-white sm:hidden"
            onClick={(e) =>
              handleTrack({ label: `self_itr_${ctaText}`, obj: e.target })
            }
          >
            <Button className="px-14 py-3 bg-blue-350 sm:ml-0 rounded-sm sm:my-2 ml-2 sm:w-full">
              {ctaText}
            </Button>
          </a>
        </If>
      </div>
    </div>
  );
};

export { SectionHeader };
